/**
 * Metadata for an export type, by file extension
 */
const exportMetadata = {
	pdf: {
		icon: 'docs-acrobat-mono',
		type: 'pdf'
	},
	pptx: {
		icon: 'docs-presentation-mono',
		type: 'powerpoint'
	},
	docx: {
		icon: 'docs-document',
		type: 'word'
	},
	png: {
		icon: 'docs-image-mono',
		type: 'png'
	},
	xlsx: {
		icon: 'docs-spreadsheet-mono',
		type: 'excel'
	},
	csv: {
		icon: 'docs-spreadsheet-mono',
		type: 'csv'
	}
}

export default exportMetadata
exportMetadata.__filename__ = 'components/export/export-metadata.js'
